import { ReactElement, Fragment, memo } from 'react';

import { RenderingFieldGroup, RenderingSubsection } from '@zinnia/form-engine-sdk';

import { FieldGroupContainer } from './FieldGroupContainer';
import { SubsectionHeader } from './SubsectionHeader';
import { CustomSubsection } from './CustomSubsections/CustomSubsection';

type SubsectionViewProps = {
  subsection: RenderingSubsection;
};

export const SubsectionView = memo(InnerSubsectionView);

export function InnerSubsectionView(props: SubsectionViewProps): ReactElement | null {
  const { subsection } = props;

  if (!subsection.visible) return null;

  if ((subsection as any).custom) {
    // TODO: remove typecast once the new version of the sdk is deployed
    return <CustomSubsection subsection={subsection} />;
  }

  return (
    <Fragment>
      <SubsectionHeader title={subsection.title} text={subsection.text} />

      {subsection.fieldGroups.map((fieldGroup: RenderingFieldGroup) => (
        <FieldGroupContainer key={fieldGroup.id} fieldGroup={fieldGroup} />
      ))}
    </Fragment>
  );
}
